import { setAlertError } from '../alert/alert.slice';

export const handleThunkError = (error, thunkAPI, fallbackMessage = 'Something went wrong') => {
  const data = error?.response?.data;

  const message =
    data?.message ||
    data?.error ||
    (Array.isArray(data?.errors) ? data.errors.join(', ') : null) ||
    error?.message ||
    fallbackMessage;

  const details = data?.details || null;

  const alertMessage = [message, details].filter(Boolean).join('\n');

  thunkAPI.dispatch(setAlertError(alertMessage));

  return thunkAPI.rejectWithValue({
    message,
    details,
    status: error?.response?.status || null
  });
};
